<template>
  <div class="b-wrapper">
    <ul class="flx-row" style="margin:0px"></ul>
    <ul class="flx-row">
      <li>
        <p   style="text-indent: 0.6rem;text-align: justify;line-height:20px;color:#707070">
        {{$t('tag.zangfujielu.'+item.id+'.'+ item.text)}}
        </p>
      
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'warnData',
  props: ['item']
}
</script>

<style lang="stylus" scoped>
.b-wrapper
  margin .2rem 0
  display flex
  flex-flow column
  .flx-row
    display flex
    flex-flow row nowrap
    justify-content space-around
    align-items center
    margin .2rem 0
    font-size .26rem
    li
      display flex
      flex-flow column
      .orange
        color orange
      .red
        color red
      &:nth-child(2)
        .iconfont
          color #3696ea
          font-size .6rem
          font-weight bold
      p
        &:nth-child(2)
          margin-top .3rem
        strong
          font-size .4rem
          font-weight bold
    &:nth-child(1)
      li
        &:nth-child(1)
          p
            &:nth-child(1)
              color #3596ea
</style>



// WEBPACK FOOTER //
// src/pages/common/components/warnData.vue